/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Project_Token = {
    /**
     * ID of the project_token
     */
    token: string;
    /**
     * ID of the workspace
     */
    workspaceId: string;
    /**
     * ID of the project
     */
    projectId: string;
    createdBy: string;
    /**
     * Name of the token
     */
    name: string;
    lastActive: string | null;
    created: string;
    updated: string;
    _object: Project_Token._object;
};
export namespace Project_Token {
    export enum _object {
        PROJECT_TOKEN = 'project_token',
    }
}

